module.exports = __webpack_public_path__ + "static/media/Dt2.f39f7b56.jpg";